<template>
  <v-app>
    <v-fade-transition mode="out-in">
      <div class="bg-image-container" v-if="!isAuthorized">
        <div class="bg-image" :style="{backgroundImage: 'url(\'' + bgImageUrl + '\')'}">
          <div class="bg-overlay"></div>
        </div>
      </div>
    </v-fade-transition>

    <app-menu :show="isAuthorized && $store.getters.canAccessProduct" />
    <transition name="menu-slide-from-bottom" mode="out-in">
      <div v-if="isAuthorized">
        <app-bar />
      </div>
    </transition>

    <v-main>
      <v-container fluid style="height: 100%;" :class="containerBackground">
        <transition name="fade-up" mode="out-in" appear>
          <router-view v-if="showContent" />
        </transition>
      </v-container>
    </v-main>

    <v-footer
      inset
      app
      v-if="isAuthorized"
    >
      <v-row>
        <v-col>
          <span>Need Help? Email support@wealthyiq.com</span>
        </v-col>
        <v-col class="text-right">
          <span class="px-4">Wealthy IQ &copy; {{ new Date().getFullYear() }} <small class="px-4"><a href="https://wealthyiq.com/privacy-policy/" target="_blank">Privacy Policy</a></small> <small class="grey--text ml-2">v{{ $root.version }}</small></span>
        </v-col>
      </v-row>
    </v-footer>
    
  </v-app>
</template>

<script>
import AppMenu from '@/components/AppMenu'
import AppBar from '@/components/AppBar'

export default {
  name: 'App',
  components: {
    AppMenu,
    AppBar
  },
  data: () => ({
    showContent: false
  }),
  mounted() {
    if(this.isAuthorized) {
      this.showContent = true
    } else {
      setTimeout(() => {
        this.showContent = true
      }, 200)
    }
  },
  computed: {
    isAuthorized() {
      return this.$store.getters.isAuthorized
    },
    bgImageUrl() {
      return this.$root.cdn + 'bg1.jpg';
    },
    containerBackground() {
      if(this.$route.meta.background) return this.$route.meta.background
      return ''
    }
  }
};
</script>

<style lang="scss">
  @import './assets/scss/_main.scss';
</style>
